import { Messages } from 'config';

export const parseAxiosError = (error: any) => {
  const message = error?.response?.data?.message;
  const axiosError = (Array.isArray(message) && message.join(', ')) || message;
  if (axiosError) {
    return axiosError;
  }
  return error.message;
};

export const getErrorMessage = (error: any) => {
  if (typeof error === 'string') {
    return error;
  }
  const message = error?.response?.data?.message;
  return (
    (Array.isArray(message) && message.join(', ')) ||
    message ||
    error?.message ||
    Messages.SOMETHING_WENT_WRONG
  );
};
